"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function () {
  var ownKeys = function (o) {
    ownKeys = Object.getOwnPropertyNames || function (o) {
      var ar = [];
      for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
      return ar;
    };
    return ownKeys(o);
  };
  return function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
    __setModuleDefault(result, mod);
    return result;
  };
}();
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Label = exports.Input = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const Label_1 = __importDefault(require("../Label"));
exports.Input = styled_components_1.default.input`
  width: 100%;
  height: 30px;
  border: 1px solid;
  color: ${props => props.theme.colors.black};
  font-family: 'Roboto', sans-serif;
  font-size: ${props => props.theme.fontSizes[12]};
  border-color: ${props => props.theme.colors.beige_400};
  border-radius: 4px;
  outline: 0;
  padding: 0 8px 0 10px;
  &:hover,
  &:focus {
    ${props => !props.disabled && (0, styled_components_1.css)`
        border-color: ${props.theme.colors.primary_700_main};
      `}
  }
  &::placeholder {
    color: ${props => props.theme.colors.gray_702};
    opacity: 0.5;
  }
  ${props => props.disabled && (0, styled_components_1.css)`
      cursor: not-allowed;
      background-color: ${props.theme.colors.gray_201};
      border-color: ${props.theme.colors.gray_201};
      color: ${props.theme.colors.gray_401};
    `}
  ${props => props.theme.isMobile && (0, styled_components_1.css)`
      height: 48px;
      border-width: 2px;
      font-size: 16px;
    `}
  ${props => props.stylesOverride};
`;
exports.Label = (0, styled_components_1.default)(Label_1.default)`
  display: inline-block;
  margin-bottom: 8px;
`;